import { RecipesCollectionRef } from 'services/firebase';
import RecipeMapper from 'services/mappers/recipes/RecipeMapper';

const mostRatedRecipes = async () => {
  const querySnapshot = await RecipesCollectionRef()
    .orderBy('likes', 'desc')
    .limit(3)
    .get();

  const recipes = querySnapshot.docs.map((doc) =>
    RecipeMapper.mapFirebaseRefToModel(doc.id, doc.data())
  );

  return recipes;
};

export default mostRatedRecipes;
